async function sha256base64url(str: string): Promise<string> {
  const data = new TextEncoder().encode(str);
  const hash = await crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode(...new Uint8Array(hash)))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

function randomBase64url(length: number): string {
  const arr = new Uint8Array(length);
  crypto.getRandomValues(arr);
  return btoa(String.fromCharCode(...arr))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

export async function startOidcFlow(oidcConfig: { client_id: string; issuer: string }): Promise<void> {
  const issuer = oidcConfig.issuer.endsWith("/") ? oidcConfig.issuer : oidcConfig.issuer + "/";
  const codeVerifier = randomBase64url(32);
  const codeChallenge = await sha256base64url(codeVerifier);
  const state = randomBase64url(16);
  sessionStorage.setItem("oidc_pkce", JSON.stringify({ code_verifier: codeVerifier, state }));
  const redirectUri = window.location.origin + "/oidc-callback";
  const params = new URLSearchParams({
    response_type: "code",
    client_id: oidcConfig.client_id,
    redirect_uri: redirectUri,
    scope: "openid urn:matrix:org.matrix.msc2967.client:api:*",
    code_challenge: codeChallenge,
    code_challenge_method: "S256",
    state,
  });
  window.location.href = issuer + "authorize?" + params.toString();
}
